import { useScaffold } from "@Light/scaffold";
import { DocumentsResponse } from "@Light/services/lightTypes";
import { formatBrandedPlanName } from "@Light/utils/formatting";
import { StatusChip } from "./StatusChip";
import clsx from "clsx";
import dayjs from "dayjs";
import { DocumentsSelectorLink } from "./DocumentsSelectorLink";

export type DocumentsSelectorItemProps = {
  docSet: DocumentsResponse;
};

function useStatus(docSet: DocumentsResponse): string | null {
  if (docSet.is_active) {
    return "Current";
  }
  if (docSet.is_queued) {
    return "Upcoming";
  }
  return null;
}

export const DocumentsSelectorItem: React.FC<DocumentsSelectorItemProps> = ({
  docSet,
}) => {
  const st = useStatus(docSet);
  const scaffold = useScaffold();
  const DetailLabel = scaffold.page.detail.detailLabel;
  return (
    <DocumentsSelectorLink to={`/account/documents/set/${docSet.uuid}`}>
      <div className="flex flex-row gap-2 items-center">
        <DetailLabel>
          {formatBrandedPlanName(scaffold.page, docSet.plan_name)}
        </DetailLabel>
        {st && <StatusChip>{st}</StatusChip>}
      </div>
      <div
        className={clsx(
          "text-sm font-regular",
          scaffold.page.colors.text.secondary,
        )}
      >
        {dayjs(docSet.contract_start).format("MMMM YYYY")} {" - "}
        {dayjs(docSet.contract_end).format("MMMM YYYY")}
      </div>
    </DocumentsSelectorLink>
  );
};
